// @ts-check

import ToolCall from "@/components/tool-call";
import { BrainCog } from "lucide-react";
import z from "zod";
import { ChatMarkdown } from "../ChatBubble";

const AgentTaskArgsSchema = z.object({
  task: z.string()
})

const AgentTaskResultSchema = z.object({
  content: z.string()
})

/** @param {import(".").ToolComponentProps<typeof AgentTaskArgsSchema, typeof AgentTaskResultSchema>} props */
function AgentTaskUI({ args, result, state }) {
  const output = (() => {
    if(result == null) return null
    if(result instanceof Error) return result.message
    return result.content
  })()

  return (
    <ToolCall state={state}>
      <ToolCall.Header>
        <BrainCog size={16} className="shrink-0" />
        <ToolCall.Action>Task</ToolCall.Action>
        <ToolCall.Input>
          <span>{args.task}</span>
        </ToolCall.Input>
      </ToolCall.Header>

      <ToolCall.Content>
        <ToolCall.Output>
          {state === ToolCall.State.SUCCESS ? (
            <ChatMarkdown>{output}</ChatMarkdown>
          ): output}
        </ToolCall.Output>
      </ToolCall.Content>
    </ToolCall>
  )
}

export {
  AgentTaskArgsSchema,
  AgentTaskResultSchema,
  AgentTaskUI,
}